const Tag = ({ title }) => {
  return <div className="tag"><span>{title}</span></div>;
};

export default Tag;
